import { Sticky } from "../../types";
import { LostItemLogsData } from "../../types/ActivityLog";
import { convertUtcToLocal } from "./convertUtcToLocal";

export const sortStickyData = (data: Sticky[]): Sticky[] => {
  if (!data || data?.length === 0) {
    return data || []; // or return an empty array: return []
  }

  return [...data]?.sort((a, b) => {
    // First, check if status is 1 to prioritize them
    if (a?.status === 1 && b?.status !== 1) {
      return -1; // a should come first
    }
    if (b?.status === 1 && a?.status !== 1) {
      return 1; // b should come first
    }

    // If both statuses are the same, sort by createdAt
    const aLocalTime = convertUtcToLocal(a?.createdAt, "YYYY-MM-DD HH:mm:ss");
    const bLocalTime = convertUtcToLocal(b?.createdAt, "YYYY-MM-DD HH:mm:ss");

    return new Date(bLocalTime)?.getTime() - new Date(aLocalTime)?.getTime();
  });
};

export const sortLostItemLogsData = (data: LostItemLogsData[]): LostItemLogsData[] => {
  if (!data || data?.length === 0) {
    return data || []; // or return an empty array: return []
  }

  return [...data]?.sort((a, b) => {
    // If both statuses are the same, sort by createdAt
    const aLocalTime = convertUtcToLocal(a?.createdAt, "YYYY-MM-DD HH:mm:ss");
    const bLocalTime = convertUtcToLocal(b?.createdAt, "YYYY-MM-DD HH:mm:ss");

    return new Date(bLocalTime)?.getTime() - new Date(aLocalTime)?.getTime();
  });
};
